"use client";
import styled from "@emotion/styled";

import { Button } from "../Button";

export const Root = styled(Button)`
  --mask-icon-color: inherit;
`;
